<template>
  <base-details-header :structure="headerStructure" :el="selectedManager" />
  <base-subpage-bar :headers="headers" />
  <router-view />
</template>

<script>
  import { computed, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { useStore } from 'vuex';
  export default {
    setup() {
      //  INIT
      const store = useStore();
      const route = useRoute();
      //  ASSIGN ELEMENTS
      const selectedElID = { id: route.params.managerId };
      onMounted(() => {
        store.dispatch('getSelectedManager', selectedElID);
      });
      const selectedManager = computed(() => {
        return store.getters.selectedManager;
      });
      //  CREATE OBJ FOR DETAILS HEADER
      const headers = [
        {
          text: 'paths.overall',
          name: 'menu.sharing.managerDetails',
        },
        {
          text: 'paths.locations',
          name: 'menu.sharing.managerLocations',
        },
        {
          text: 'paths.relatedVehicles',
          name: 'menu.sharing.managerVehicles',
        },
        {
          text: 'paths.relatedUsers',
          name: 'menu.sharing.managerUsers',
        },
        {
          text: 'paths.relatedRentals',
          name: 'menu.sharing.managerRentals',
        },
      ];
      const headerStructure = {
        title: [
          {
            title: 'name',
          },
        ],
        data: [
          {
            name: 'id',
            placeholder: '@',
          },
          {
            name: 'address',
          },
        ],
      };

      return {
        selectedManager,
        headerStructure,
        headers,
      };
    },
  };
</script>
<style></style>
